<template>
  <b-card title="سجل المستخدم">
    <log-timeline :events="items" />
  </b-card>
</template>

<script>
import { BCard, BImg, BMedia, BAvatar } from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import LogTimeline from "@/components/log-timeline/index.vue";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BCard,
    BImg,
    BMedia,
    BAvatar,
    AppTimeline,
    AppTimelineItem,
    LogTimeline,
  },
};
</script>

<style></style>
